// package imports
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

// CSS imports
import './NewsletterEmailCard.css';

// Component imports
import DeleteButton from '../buttons/deleteButton/DeleteButton';
import Spinner from '../spinner/Spinner';
import PrimaryButton from '../buttons/primaryButton/PrimaryButton';
import TransparentButton from '../buttons/transparentButton/TransparentButton';

// Icon imports
import { FaRegCopy } from 'react-icons/fa6';

// Type imports
import { NewsletterEmail } from '../../types/newsletter/NewsletterEmail';

type Props = {
  className?: string;
  email: NewsletterEmail;
  index: number;
  deleteEmail: (id: string, x: number) => Promise<void>;
  duplicateEmail: (id: string) => Promise<void>;
  sendEmail: (id: string) => Promise<void>;
};

const NewsletterEmailCard: React.FC<Props> = ({
  className,
  email,
  index,
  deleteEmail,
  duplicateEmail,
  sendEmail,
}: Props) => {
  const [isLoading, setIsLoading] = useState(false);

  const triggerDeleteEmail = async () => {
    setIsLoading(true);
    await deleteEmail(email.id, index);
    setIsLoading(false);
  };

  const triggerSendEmail = async () => {
    setIsLoading(true);
    await sendEmail(email.id);
    setIsLoading(false);
  };

  const triggerDuplicateEmail = async () => {
    setIsLoading(true);
    await duplicateEmail(email.id);
    setIsLoading(false);
  };

  return (
    <div className={`NewsletterEmailCard ${className ? className : ''}`}>
      <div className='side-container'>
        <div className='label-container'>
          <span className='name-text'>{email.name}</span>
          <span className='subject-text'>{email.subject}</span>
        </div>
      </div>
      <div className='side-container'>
        <PrimaryButton
          label='Send'
          onClick={triggerSendEmail}
          className='action-button'
        />
        <Link to={'/newsletter-email/' + email.id} className='edit-link'>
          <PrimaryButton label='Edit' className='action-button' />
        </Link>
        <TransparentButton
          ReactIcon={FaRegCopy}
          onClick={triggerDuplicateEmail}
          className='icon-button'
        />
        <DeleteButton onClick={triggerDeleteEmail} />
      </div>
      {isLoading ? (
        <div className='loader-overlay'>
          <Spinner isLoading={true} />
        </div>
      ) : null}
    </div>
  );
};

export default NewsletterEmailCard;
